export default __webpack_public_path__ + "static/Messenger-20f482606b2a87c6c06b37240fc50bc3.svg";